export const sortableColumns = {
    username: 'username',
    lastActionDate: 'lastActionDate',
    email: 'email',
    role: 'role'
};
export const availableConstituents = ['ai', 'idep', 'cwm'];
